import styled from 'styled-components';

export const StyledRegister = styled.div``;

export const StyledRegisterSuccessText = styled.div`
  font-size: 1rem;
  margin-bottom: 1rem;
`;
